import store from "../store";

// Fallback de imagens de conteúdo (produto, banner, logo) quando o arquivo não existe ou não carrega.
// Produto: imagem padrão por tipo (mesma regra de api/src/app/util/genericProductImage.js), servida
// pela api em /products/images/<empresa>/<arquivo> — da rede, ou a neutra quando a rede não tiver.
// Se até ela falhar, entra o SVG embutido (não depende de rede, evita laço de erro).

const EMBEDDED_PRODUCT_SVG =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">' +
  '<rect width="200" height="200" fill="#F5F6F8"/>' +
  '<g fill="none" stroke="#9CA3AF" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">' +
  '<rect x="55" y="62" width="90" height="76" rx="8"/>' +
  '<circle cx="82" cy="88" r="9"/>' +
  '<path d="M55 126l28-26 22 20 14-12 26 22"/>' +
  "</g></svg>";

const EMBEDDED_PRODUCT_IMAGE = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(EMBEDDED_PRODUCT_SVG)}`;

export function genericProductImageName(product) {
  if (product?.tarja === "V") return product.generico ? "no-image-generico-tarja-vermelha.jpg" : "no-image-tarja-vermelha.jpg";
  if (product?.tarja === "P") return product.generico ? "no-image-generico-tarja-preta.jpg" : "no-image-tarja-preta.jpg";
  if (product?.tipo === 6) return "no-image-perfumaria.jpg";
  if (product?.generico) return "no-image-generico.jpg";
  return "no-image-mip.jpg";
}

export function defaultProductImage(product) {
  const companyUrl = store.getState().store?.data?.empresa?.url;
  if (!companyUrl) return EMBEDDED_PRODUCT_IMAGE;
  return `${process.env.REACT_APP_API_URL}/products/images/${companyUrl}/${genericProductImageName(product)}`;
}

// Primeira imagem do produto ou a padrão (lista vazia/nula não gera <img> quebrado).
export const productImageSrc = (product) => product?.imagens?.[0]?.caminho_imagem || defaultProductImage(product);

// onError de imagem de produto: 1ª falha → imagem padrão do tipo; 2ª → SVG embutido; depois para.
export const handleProductImageError = (product) => (event) => {
  const img = event.currentTarget;
  const tentativa = Number(img.dataset.fallback || 0);
  if (tentativa >= 2) return;
  const padrao = defaultProductImage(product);
  const proxima = tentativa === 0 && img.src !== padrao ? padrao : EMBEDDED_PRODUCT_IMAGE;
  img.dataset.fallback = String(proxima === EMBEDDED_PRODUCT_IMAGE ? 2 : 1);
  img.src = proxima;
};

// onError de banner, logo e propaganda: some com a imagem em vez de mostrar o ícone quebrado.
export const hideImageOnError = (event) => {
  event.currentTarget.style.visibility = "hidden";
};
